// For now this class is only used to play UI sounds
import * as Tone from 'tone';

const selectSound = require('url:../src/assets/sounds/select.mp3');
const discardSound = require('url:../src/assets/sounds/discard.mp3');
const saxoSelectSound = require('url:../src/assets/sounds/saxo_select.mp3');
const trumpetSelectSound = require('url:../src/assets/sounds/trumpet_select.mp3');
const violinSelectSound = require('url:../src/assets/sounds/violin_select.mp3');
const fluteSelectSound = require('url:../src/assets/sounds/flute_select.mp3');
const guitarSelectSound = require('url:../src/assets/sounds/guitar_select.mp3');
const birdSelectSound = require('url:../src/assets/sounds/bird_select.mp3');
const whaleSelectSound = require('url:../src/assets/sounds/whale_select.wav');
const scratchSelectSound = require('url:../src/assets/sounds/scratch_select.mp3');
const yoSelectSound = require('url:../src/assets/sounds/yo_select.mp3');
const sealSelectSound = require('url:../src/assets/sounds/seal_select.mp3');

const VOLUME = -14;

class MediaPlayer {
  constructor() {
    this.sounds = {
      select: this.createPlayer(selectSound),
      discard: this.createPlayer(discardSound, -20),
      saxo: this.createPlayer(saxoSelectSound),
      trumpet: this.createPlayer(trumpetSelectSound),
      violin: this.createPlayer(violinSelectSound),
      flute: this.createPlayer(fluteSelectSound),
      guitar: this.createPlayer(guitarSelectSound),
      bird: this.createPlayer(birdSelectSound),
      whale: this.createPlayer(whaleSelectSound),
      scratch: this.createPlayer(scratchSelectSound),
      yo: this.createPlayer(yoSelectSound),
      seal: this.createPlayer(sealSelectSound),
    };
  }

  createPlayer(url, volume = VOLUME) {
    const player = new Tone.Player({
      url: url,
      loop: false,
      autostart: false,
    }).toDestination();
    player.volume.value = volume;
    return player;
  }

  playSelect() {
    this.playSound(this.sounds.select);
  }

  playDiscard() {
    this.playSound(this.sounds.discard);
  }

  playSound(player) {
    if (player.loaded) {
      player.start();
    }
  }

  playSelectInstrument(index) {
    switch (index) {
      case 0:
        this.playSound(this.sounds.flute);
        break;
      case 1:
        this.playSound(this.sounds.saxo);
        break;
      case 2:
        this.playSound(this.sounds.trumpet);
        break;
      case 3:
        this.playSound(this.sounds.violin);
        break;
      case 4:
        this.playSound(this.sounds.guitar);
        break;
      case 5:
        this.playSound(this.sounds.select);
        break;
      case 6:
        this.playSound(this.sounds.bird);
        break;
      case 7:
        this.playSound(this.sounds.whale);
        break;
      case 8:
        this.playSound(this.sounds.scratch);
        break;
      case 9:
        this.playSound(this.sounds.yo);
        break;
      case 10:
        this.playSound(this.sounds.seal);
        break;
    }
  }
}

export { MediaPlayer };
